
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sub/domains",
      function () {
        return require("private-next-pages/sub/domains.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sub/domains"])
      });
    }
  